import { createContext, useContext } from 'react'

export type PestanaId = 'hoy' | 'platos' | 'compra' | 'recetas' | 'ajustes' | 'admin'

/** Saltar de una pantalla a otra sin router: la app sólo tiene cinco. */
export const NavegacionContext = createContext<(pestana: PestanaId) => void>(() => {})

export function useIrA(): (pestana: PestanaId) => void {
  return useContext(NavegacionContext)
}
